import React from 'react';

//importing header
import Header from './header/header.component';
import Main from './main/main.component';

const Home = () => {
    return (
        <>
            <Header />
            <Main />
        </>
    );
}

export default Home;